import type {YearOrDateValue} from 'schemaDefinition/types';

export const isYear = (
  yearOrDate: YearOrDateValue | null | undefined,
): boolean => {
  // Year: no object or no date (since: date => no year)
  return !yearOrDate || typeof yearOrDate.date !== 'string';
};
